import React from 'react';
import { motion } from 'framer-motion';
import { scenarios } from '../data/scenarios';
export function UseCases() {
  return <section className="py-24 px-4 bg-pearl-light border-y border-pearl-dark" data-id="element-276" data-mp="3a98b6s933sp5">
      <div className="max-w-4xl mx-auto" data-id="element-277" data-mp="35gf6u5hj2mdl">
        <div className="text-center mb-12" data-id="element-278" data-mp="35f43g6rzvgn0">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-279" data-mp="31g53l0l4ea2f">
            Think About What You Can Do With This Library
          </h2>
        </div>

        <ul className="space-y-3 mb-12" data-id="element-280" data-mp="2we5z1ndn973w">
          {scenarios.map((scenario, index) => <motion.li key={scenario.situation} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-pearl-dark rounded-xl px-6 py-5 sm:flex sm:items-baseline sm:justify-between sm:gap-6" data-id="element-281" data-mp="2rjijwf4j5p1z" data-mpi={index}>
              <p className="text-graphite" data-id="element-282" data-mp="2rto22o0dcix8">{scenario.situation}</p>
              <p className="text-navy font-bold mt-1 sm:mt-0 sm:text-right shrink-0" data-id="element-283" data-mp="2rwk2qk3lplpd">
                {scenario.answer}
              </p>
            </motion.li>)}
        </ul>

        <div className="max-w-2xl mx-auto text-center" data-id="element-284" data-mp="2ivlyc0p93c69">
          <p className="text-xl font-serif font-bold text-navy mb-2" data-id="element-285" data-mp="2mw5t4xmcq3p8">
            This is why Swim Instructor Ready is more than a collection of PDFs.
          </p>
          <p className="text-lg text-graphite" data-id="element-286" data-mp="3fjs5ovdk4io8">
            It is a teaching system designed around the situations instructors actually face.
          </p>
        </div>
      </div>
    </section>;
}